/**
 * #1217 D1 — double-submit CSRF token helpers.
 *
 * The BFF mints a readable `csrf_token` cookie; the frontend echoes it as the
 * `X-CSRF-Token` header on unsafe methods. The BFF validates header == cookie
 * unconditionally (the `BFF_ENFORCE_CSRF` leash was retired in #1337). The
 * cookie is intentionally NOT HttpOnly so the SPA can read it here.
 */

export const CSRF_COOKIE_NAME = 'csrf_token';
export const CSRF_HEADER = 'X-CSRF-Token';

/** Read the BFF-minted `csrf_token` cookie, or null if not present. */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}
